import { render, staticRenderFns } from "./ProductSummaryByTract.vue?vue&type=template&id=2a0c7d8b&"
import script from "./ProductSummaryByTract.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryByTract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports